<template>
  <v-form
    :value="valid"
    @input="v => $emit('update:valid', v)"
    @submit.prevent=""
  >
    <v-row align="center" dense class="mb-2">
      <span class="subtitle-1 gutters">Cette recette produit</span>
      <v-col cols="12" sm="2">
        <j-decimal-input
          filled
          dense
          class="no-before"
          type="number"
          :min="0.0001"
          required
          auto-hide-details
          :value="quantite_produite"
          @change="v => $emit('update:quantite_produite', v)"
          label="Quantité produite"
        ></j-decimal-input>
      </v-col>
      <v-col cols="12" sm="2">
        <v-select
          filled
          dense
          class="no-before"
          :items="getAllowedUnits"
          :value="unite_produite"
          required
          hide-details="auto"
          :rules="[
            v => v !== null || 'Une unité de mesure est nécessaire',
            v => v !== undefined || 'Une unité de mesure est nécessaire'
          ]"
          @change="v => $emit('update:unite_produite', v)"
          label="Unité produite"
        ></v-select>
      </v-col>
      <v-spacer></v-spacer>
      <v-tooltip right v-if="est_intermediaire">
        <template v-slot:activator="{ on }">
          <v-btn
            small
            v-on="on"
            text
            @click="alwaysProduceQuantityModel = !alwaysProduceQuantityModel"
            :color="alwaysProduceQuantityModel ? 'success' : ''"
          >
            <v-icon small left>mdi-beaker</v-icon>
            Production fixe
          </v-btn>
        </template>
        <span
          >Toujours préparer en lot égal à la quantité produite de la
          recette</span
        >
      </v-tooltip>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "RecipeProductionInput",
  props: {
    quantite_produite: {
      required: true
    },
    unite_produite: {
      required: true
    },
    always_produce_quantity: {
      required: true
    },
    est_intermediaire: {
      type: Boolean,
      required: true
    },
    valid: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getAllowedUnits"]),
    alwaysProduceQuantityModel: {
      get() {
        return this.always_produce_quantity;
      },
      set(newValue) {
        this.$emit("update:always_produce_quantity", newValue);
      }
    }
  }
};
</script>

<style scoped>
.gutters {
  padding: 4px;
}
</style>
